import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const divider = (bg = '#fff') => css`
  width: 100%;
  height: 100px;
  background-color: ${bg};
`

export const defaultVariant = css`
  height: ${size[64]};

  ${breakpoint.up('smMd')} {
    height: ${size[160]};
  }

  &:first-of-type,
  &:last-of-type {
    height: ${size[32]};

    ${breakpoint.up('smMd')} {
      height: ${size[80]};
    }
  }
`

export const additionalVariant = css`
  height: ${size[48]};

  ${breakpoint.up('smMd')} {
    height: ${size[128]};
  }

  &:first-of-type,
  &:last-of-type {
    height: ${size[24]};

    ${breakpoint.up('smMd')} {
      height: ${size[64]};
    }
  }
`
